import { firebaseAuth, firebaseDB } from '@/config/firebaseConfig'

const state = {
  isLoggedIn: firebaseAuth().currentUser != null,
  user: firebaseAuth().currentUser
}

const mutations = {
  'AUTH_STATUS_CHANGE' (state) {
    state.isLoggedIn = firebaseAuth().currentUser != null
    state.user = firebaseAuth().currentUser
  }
}

const actions = {
  loginWithEmail (_, { email, password }) {
    return firebaseAuth().signInWithEmailAndPassword(email, password)
  },
  resetPassword (_, { email }) {
    return firebaseAuth().sendPasswordResetEmail(email)
  },
  saveUserDetails ({ commit, getters }, { uid, firstname, lastname, mobile }) {
    return firebaseDB().ref(`/customers/${uid}`).update({ firstname: firstname, lastname: lastname, phone: mobile })
  },
  registerByEmail  (_, { email, password }) {
    return firebaseAuth().createUserWithEmailAndPassword(email, password)
  },
  authStateChanged ({ commit, getters, dispatch }) {
    console.log('auth state changned')
    commit('AUTH_STATUS_CHANGE')
    if (getters['isLoggedIn']) {
      dispatch('getShops')
    }
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  currentUser: state => {
    if (state && state.user) {
      return {
        email: state.user.email,
        emailVerified: state.user.emailVerified,
        uid: state.user.uid
      }
    } else {
      return false
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
